<template>
    <a-layout class="shell">
        <a-layout-sider
            v-model:collapsed="collapsed"
            breakpoint="lg"
            :collapsed-width="0"
            :width="232"
            :trigger="null"
            class="sider"
        >
            <div class="sider-inner">
                <div class="brand">
                    <img src="../assets/mark.svg" alt="" class="brand-mark" />
                    <div class="brand-text">
                        <span class="brand-name">AD168</span>
                        <span class="brand-sub">Ops console</span>
                    </div>
                </div>

                <nav class="nav" aria-label="Main">
                    <router-link
                        v-for="item in items"
                        :key="item.to"
                        :to="item.to"
                        class="nav-item"
                        :class="{ active: isActive(item) }"
                    >
                        <component :is="item.icon" class="nav-icon" />
                        <span>{{ item.label }}</span>
                    </router-link>
                </nav>

                <div class="sider-foot">
                    <div class="who">
                        <span class="avatar">{{ initial }}</span>
                        <div class="who-text">
                            <span class="who-name">Ops admin</span>
                            <span class="who-mail">{{ email }}</span>
                        </div>
                    </div>
                    <a-button type="text" class="logout" @click="handleLogout">
                        <template #icon><LogoutOutlined /></template>
                        Log out
                    </a-button>
                </div>
            </div>
        </a-layout-sider>

        <a-layout class="main">
            <header class="topbar">
                <a-button type="text" class="menu-toggle" aria-label="Toggle menu" @click="collapsed = !collapsed">
                    <template #icon><MenuOutlined /></template>
                </a-button>
                <img src="../assets/mark.svg" alt="" class="topbar-mark" />
            </header>
            <a-layout-content class="content-body">
                <router-view/>
            </a-layout-content>
        </a-layout>
    </a-layout>
</template>

<script>
import { UserOutlined, FileTextOutlined, TeamOutlined, LogoutOutlined, MenuOutlined } from '@ant-design/icons-vue';
import { auth } from '@/firebase/config';
import { signOut } from 'firebase/auth';
import { message } from 'ant-design-vue';

export default {
    components: { LogoutOutlined, MenuOutlined },
    data() {
        return {
            collapsed: false,
            items: [
                { to: '/dashboard', label: 'Users', icon: UserOutlined, also: ['/user/', '/approve'] },
                { to: '/tickets', label: 'Tickets', icon: FileTextOutlined, also: [] },
                { to: '/affiliates', label: 'Affiliates', icon: TeamOutlined, also: [] }
            ]
        };
    },
    computed: {
        email() {
            return auth.currentUser?.email || 'ops_admin@ad168.org';
        },
        initial() {
            return this.email.charAt(0).toUpperCase();
        }
    },
    methods: {
        isActive(item) {
            const path = this.$route.path;
            return path === item.to || item.also.some((p) => path.startsWith(p));
        },
        async handleLogout() {
            try {
                await signOut(auth);
                message.success('Logged out');
                this.$router.push('/login');
            } catch (error) {
                message.error('Failed to log out');
            }
        }
    }
};
</script>

<style>
.shell { min-height: 100vh; background: var(--bg); }

.sider.ant-layout-sider { background: var(--soft); border-right: 1px solid var(--line); position: sticky; top: 0; height: 100vh; align-self: flex-start; }
.sider-inner { display: flex; flex-direction: column; height: 100%; padding: 16px 12px; }

.brand { display: flex; align-items: center; gap: 10px; padding: 4px 8px 18px; }
.brand-mark { width: 32px; height: 32px; }
.brand-text { display: flex; flex-direction: column; line-height: 1.15; }
.brand-name { font-weight: 700; font-size: 16px; letter-spacing: -0.02em; }
.brand-sub { font-size: 12px; color: var(--ink-3); }

.nav { display: flex; flex-direction: column; gap: 2px; flex: 1; }
.nav-item {
    display: flex; align-items: center; gap: 10px;
    height: 38px; padding: 0 10px; border-radius: 8px;
    color: var(--ink-2); font-size: 14px; font-weight: 500; text-decoration: none;
    transition: background 0.15s, color 0.15s;
}
.nav-item:hover { background: #efede7; color: var(--ink); }
.nav-item.active { background: #e9e6de; color: var(--ink); }
.nav-icon { font-size: 16px; }
.nav-item.active .nav-icon { color: var(--red); }

.sider-foot { border-top: 1px solid var(--line); padding-top: 12px; display: flex; flex-direction: column; gap: 8px; }
.who { display: flex; align-items: center; gap: 10px; padding: 0 6px; min-width: 0; }
.avatar { flex: none; width: 30px; height: 30px; border-radius: 50%; background: var(--ink); color: #fff; display: grid; place-items: center; font-weight: 600; font-size: 13px; }
.who-text { display: flex; flex-direction: column; min-width: 0; line-height: 1.2; }
.who-name { font-size: 13px; font-weight: 600; }
.who-mail { font-size: 12px; color: var(--ink-3); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.logout { justify-content: flex-start; color: var(--ink-2); }

.main { background: var(--bg); min-width: 0; }
.content-body { padding: 28px 32px 48px; background: var(--bg); }

.topbar { display: none; align-items: center; gap: 10px; height: 52px; padding: 0 12px; border-bottom: 1px solid var(--line); background: var(--soft); position: sticky; top: 0; z-index: 5; }
.topbar-mark { width: 26px; height: 26px; }

@media (max-width: 991px) {
    .topbar { display: flex; }
    .content-body { padding: 20px 16px 40px; }
    .sider.ant-layout-sider { position: fixed; z-index: 20; box-shadow: 0 8px 30px rgba(30, 24, 12, 0.18); }
}
</style>
